"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitFormNill = exports.hasOwn = exports.debounce = exports.deprecatedWarn = exports.warn = void 0;
var warn = function (condition, message) {
    if (condition) {
        console.warn("[@datago/components]: ", message);
    }
};
exports.warn = warn;
var deprecatedWarn = function (prop, message, replace) {
    if (replace === void 0) { replace = true; }
    (0, exports.warn)(true, "\u5C5E\u6027 [".concat(prop, "] \u5DF2\u5F03\u7528\uFF0C").concat(replace ? "\u8BF7\u4F7F\u7528\u5C5E\u6027 [".concat(message, "] \u4EE3\u66FF\uFF01") : message));
};
exports.deprecatedWarn = deprecatedWarn;
var debounce = function (fn, n) {
    if (n === void 0) { n = 100; }
    var handle;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (handle)
            clearTimeout(handle);
        handle = setTimeout(function () {
            fn.apply(void 0, args);
        }, n);
    };
};
exports.debounce = debounce;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var hasOwn = function (obj, key) { return hasOwnProperty.call(obj, key); };
exports.hasOwn = hasOwn;
var omitFormNill = function (form) {
    var res = {};
    for (var key in form) {
        if ((0, exports.hasOwn)(form, key)) {
            var value = form[key];
            if (!['', null, undefined].includes(value)) {
                res[key] = value;
            }
        }
    }
    return res;
};
exports.omitFormNill = omitFormNill;
